import { render, staticRenderFns } from "./public.vue?vue&type=template&id=44f23ef3&scoped=true"
import script from "./public.vue?vue&type=script&lang=js"
export * from "./public.vue?vue&type=script&lang=js"
import style0 from "./public.vue?vue&type=style&index=0&id=44f23ef3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f23ef3",
  null
  
)

export default component.exports